import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StackedBar from 'legacy-src/utility/StackedBar';

const { bool, array } = PropTypes;

class PerformanceBar extends Component {
  static OverInterpretingMessage = () => <span>OverInterpretingMessage</span>;

  static propTypes = {
    showLabels: bool,
    isSmall: bool,
    stacks: array.isRequired,
  };

  static defaultProps = {
    report: {},
    total: null,
    showLabels: false,
    isSmall: false,
    stacks: [],
  };

  render() {
    const { showLabels, isSmall, stacks } = this.props;
    return (
      <StackedBar isSmall={isSmall} showLabels={showLabels} stacks={stacks} />
    );
  }
}

export default PerformanceBar;
